<template>
  <button
    type="button"
    @click="open = true"
    :class="['px-2 py-1 text-left', buttonClasses]">
    <slot name="button-text">Delete</slot>

    <!-- @TODO: move to component -->
    <BaseModalConfirmation
      v-model="open"
      :danger-button="dangerButton"
      @cancel="$emit('cancel')"
      @confirm="$emit('confirm')">
      <template #heading-text>
        <slot name="modal-heading-text"></slot>
      </template>
      <template #content>
        <slot name="modal-content"></slot>
      </template>
      <template #confirm-text>
        <slot name="modal-confirm-text"></slot>
      </template>
    </BaseModalConfirmation>
  </button>
</template>

<script>
export default {
  name: 'BaseButtonConfirmation',
  props: {
    dangerButton: {
      type: Boolean,
      default: true,
    },
    linkButton: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['cancel', 'confirm'],

  data() {
    return {
      open: false,
    };
  },

  computed: {
    buttonClasses() {
      let cssClass = [];

      if (this.linkButton) {
        cssClass.push('btn-link');
      } else {
        cssClass.push('hover:text-white');
      }

      if (this.dangerButton) {
        cssClass.push('text-red-700');
        if (!this.linkButton) {
          cssClass.push('hover:bg-red-700');
        }
      } else {
        cssClass.push('text-gray-900');
        if (!this.linkButton) {
          cssClass.push('hover:bg-brand-blue');
        }
      }

      return cssClass.join(' ');
    },
  },
};
</script>
